<template>
<div class="editAreaInfo">
  <div class="return">
    <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
    <span class="border"></span>
    <span class="title">{{$t('LanguageLib.AREA_INFO')}}</span>
  </div>
  <div class="content">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
      <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave">
        {{$t('LanguageLib.SAVE')}}
      </el-button>
      <div class="ptitle">{{$t('LanguageLib.BASIC_INFORMATION')}}</div>
<!--      地区名-->
      <p class="drawerText"><span class="colorRed">*</span>{{$t('LanguageLib.AREA_NAME')}}</p>
      <el-form-item  prop="districtName">
        <el-input
          hide-required-asterisk
          style="width: 320px;"
          :maxlength="50"
          v-model="ruleForm.districtName"
          ref="districtName"
        ></el-input>
      </el-form-item>
<!--地区编号-->
      <p class="drawerText"><span class="colorRed">*</span>{{$t('LanguageLib.AREA_CODE')}}</p>
      <el-form-item ref="districtCode" prop="districtCode">
        <el-input
          hide-required-asterisk
          style="width: 320px;"
          :maxlength="50"
          v-model="ruleForm.districtCode"
          ref="districtCode"
        ></el-input>
      </el-form-item>
<!--      城市等级-->
      <p class="drawerText">{{$t('LanguageLib.CITY_LEVEL')}}</p>
      <el-form-item>
        <el-select style="width: 320px;" v-model="ruleForm.tierCity" clearable :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
          <el-option v-for="item in cityLevelList" :key="item.id" :label="item.Name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
<!--      上级地区-->
      <p class="drawerText">{{$t('LanguageLib.SUPERIOR_AREA')}}</p>
      <el-form-item>
        <el-input style="width: 320px;" class="TeInput" :readonly="true" v-model="ruleForm.parentName">
          <el-button @click="openOrgListRegion" class="openOrgList" slot="append" :style="styleStrRegion" icon="el-icon-more"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
  <!--地区-->
  <el-dialog :visible.sync="dialogTableVisibleRegion" :title="$t('LanguageLib.SELECT_AREA')"  width="360px !important">
    <DistrictTree @addcheck-treedata="getTreeCheckDataRegion" :districtData="districtData" :districtTreeData="districtTreeData" :twoNodeArr="twoNodeArr"></DistrictTree>
    <el-button style="float:right;margin-top:15px;" @click="keepOrgDataRegion" type="primary" class="searchBtn">{{$t('LanguageLib.DETERMINE')}}</el-button>
  </el-dialog>
</div>
</template>

<script>
import storeinformationApi from '../../api/storeinformation'
import DistrictTree from '@/components/regionTree.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'EditAreaInfo',
  data () {
    var checkDistrictCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.AREA_CODE') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.AREA_CODE') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkDistrictName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.AREA_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.AREA_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      styleStrRegion: 'width: 70px;height:40px;border-bottom: 1px solid #dcdfe6;border-top: 1px solid #dcdfe6;border-right: 1px solid #dcdfe6;border-radius: 0 4px 4px 0;background-color: #D8DCE6;',
      dialogTableVisibleRegion: false, // 打开地区选择视图
      loadingSave: false,
      districtData: [],
      districtTreeData: [],
      twoNodeArr: [],
      addCheckParentNameRegion: '',
      addCheckParentIdRegion: '',
      addCheckParentCodeRegion: '',
      cityLevelList: [
        { id: 1, Name: 'Tier 1 City' },
        { id: 2, Name: 'Tier 2 City' },
        { id: 3, Name: 'Tier 3 City' }
      ],

      ruleForm: {
        id: '',
        districtCode: '',
        districtName: '',
        tierCity: '',
        parentName: '',
        parentId: '',
        parentCode: ''
      },
      rules: {
        districtCode: [
          { validator: checkDistrictCode, trigger: 'blur' }
        ],
        districtName: [
          { validator: checkDistrictName, trigger: 'blur' }
        ]
      },
      AreaDetail: {},
      type: ''
    }
  },
  components: {
    DistrictTree
  },
  beforeRouteEnter (to, from, next) {
    console.log('进入之前')
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    if (to.query.type === 'edit') {
      storeinformationApi.getstoreDetail('get', '/basicdata/district/detail',
        {
          id: to.query.id
        })
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.ruleForm.id = to.query.id
            vm.ruleForm.districtCode = res.data.districtCode
            vm.ruleForm.districtName = res.data.districtName
            vm.ruleForm.parentId = res.data.parentId
            vm.ruleForm.tierCity = res.data.tierCity
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    } else {
      NProgress.done()
      next(vm => {
        console.log(vm)
      })
    }
  },
  mounted () {
    const query = this.$route.query
    console.log(query)
    this.ruleForm.parentName = query.parentName
    console.log('////////////////////')
    console.log(this.ruleForm)
    console.log('////////////////////')
    this.addCheckParentNameRegion = query.parentName
    this.type = query.type
    if (this.type === 'add') {
      this.ruleForm.parentId = query.parentId
      this.ruleForm.parentName = query.parentName
    }
    this.getAreaTreeData()
  },
  methods: {
    getDataDetail () {
      console.log('被调用了')
    },
    goReturn () {
      this.$router.push('/storeinformation/areasetting')
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm)
          if (this.type === 'edit') {
            const rl = {
              districtCode: this.ruleForm.districtCode,
              districtName: this.ruleForm.districtName,
              id: this.ruleForm.id,
              parentId: this.ruleForm.parentId,
              tierCity: this.ruleForm.tierCity
            }
            console.log(rl)
            storeinformationApi.updateAreaData('post', '/basicdata/district/update', rl)
              .then(
                res => {
                  console.log(res)
                  console.log('修改成功')
                  this.$router.push('/storeinformation/areasetting')
                }
              ).catch(
                err => {
                  this.$commonfun.console.log(err)
                }
              )
          } else if (this.type === 'add') {
            if (!this.ruleForm.tierCity) {
              this.ruleForm.tierCity = null
            }
            if (!this.ruleForm.parentId) {
              this.ruleForm.parentId = null
            }
            const rl = {
              districtCode: this.ruleForm.districtCode,
              districtName: this.ruleForm.districtName,
              parentId: this.ruleForm.parentId,
              tierCity: this.ruleForm.tierCity
            }
            storeinformationApi.addAreaData('post', '/basicdata/district/add', rl)
              .then(
                res => {
                  console.log(res)
                  console.log('新增成功')
                  this.$router.push('/storeinformation/areasetting')
                }
              ).catch(
                err => {
                  console.log(err)
                  this.$commonfun.console.log(err)
                }
              )
          }
        }
      })
    },
    openOrgListRegion () {
      console.log('点击打开地区树')
      this.dialogTableVisibleRegion = true
    },
    getTreeCheckDataRegion (data) {
      this.$commonfun.console.log(data)
      this.addCheckParentNameRegion = data.districtName
      this.addCheckParentIdRegion = data.id
      this.addCheckParentCodeRegion = data.districtCode
    },
    // 保存树数据-地区
    keepOrgDataRegion () {
      this.dialogTableVisibleRegion = false
      this.ruleForm.parentName = this.addCheckParentNameRegion
      this.ruleForm.parentId = this.addCheckParentIdRegion
      this.ruleForm.parentCode = this.addCheckParentCodeRegion
    },
    getAreaTreeData () {
      storeinformationApi.getAreaTree('get', 'basicdata/GetDistrict')
        .then(
          res => {
            this.districtData = res.data
            const area = {}
            area.id = '00000000-0000-0000-0000-000000000000'
            area.tierCity = null
            area.districtCode = null
            area.districtName = this.$t('LanguageLib.AREA1')
            this.districtData.unshift(area)
            console.log(this.districtData)
            var dtd = this.$commonfun.toRegionTree(res.data, 'childDomainTrees', 'id', 'parentId')
            this.districtTreeData = dtd
          }
        ).catch(
          err => {
            this.$commonfun.console.log(err)
          }
        )
    }
    // 保存树数据-地区
  }
}
</script>

<style lang="scss">
.editAreaInfo{
  height: 100%;
  width: 100%;

  .ptitle {
    font-size: 16px;
    color: #000;
    font-weight: normal;
    padding-top: 8px;
    margin-bottom: 16px;
  }
  .left {
    background: #fff;
    width: 320px;
    float: left;
    height: 100%;
    border-right: 1px solid #f2f2f2;

    .treeBox {
      height: 485px;
    }
  }

  .TeInput input {
    border-right: 0px;
    border-radius: 4px 0 0 4px;
  }

  .return {
    padding-left: 25px;
    position: relative;
    height: 50px;
    background: rgba(255, 255, 255, 1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;

    .el-icon-back {
      margin-right: 15px;
      cursor: pointer;
    }

    .border {
      position: absolute;
      height: 37px;
      border-left: 1px solid #f1f1f1;
      display: inline-block;
      top: 5px;
    }

    .title {
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      margin-left: 15px;
    }
  }
  .el-dialog{
    width: 1000px !important;
    .el-dialog__body{
      overflow-y: auto;
    }
    .checkFiled{
      height: 100%;
      border-right: 1px solid #D8DCE6;
      width: calc(70% - 21px);
      padding-right: 20px;
      float: left;
      h4 {
        font-size: 14px;
        color: #999999;
        font-weight: normal;
        padding-bottom: 10px;
        border-bottom: 1px solid #D8DCE6;
        margin-bottom: 15px;
      }
      .contentTop{
        margin-bottom: 15px;
      }
      .el-checkbox{
        margin-bottom: 15px;
      }
    }
    .showFiled{
      width: calc(30% - 20px);
      float: left;
      padding-left: 20px;
      li{
        margin-top: 10px;
        position: relative;
        span{
          padding-right: 20px;
          display: block;
        }
        .el-icon-close{
          position: absolute;
          right: 0;
          top: 3px;
          cursor: pointer;
        }
      }
    }
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
    background: #E1E1E1;
  }

  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
    border-radius: 5px;
    background: #fff;
  }

  .content {
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    width: 100%;
    height: calc(100% - 50px);
    overflow-y: auto;
    padding-left: 100px;
    padding-top: 15px;

    .drawerText {
      margin-bottom: 5px;
      height: 16px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(77, 77, 77, 1);
      line-height: 16px;
    }
  }

  // 修改按钮样式
  .el-button--primary {
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }

  .colorRed {
    color: red;
  }

  // 组织树视图
  .el-dialog {
    overflow: hidden;
  }

  .el-textarea__inner {
    font: 400 14px Arial;
  }

  .el-input .is-disabled {
    color: #2c3e50;
  }
  .colorRed{
    color: red;
  }
}

</style>
